const messages = {
  es: {
    botonMainInfo: 'Conócela aquí',
    siguenos: 'Siguenos en',
    desarrollado: 'Desarrollado por',
  },
  en: {
    botonMainInfo: 'Get to know it here',
    siguenos: 'Follow Us on',
    desarrollado: 'Developed by'
  }
}

export default messages;